import React from 'react';
import FacebookSvg from './svgs/FacebookSvg';
import GithubSvg from './svgs/GithubSvg';
import LinkedinSvg from './svgs/LinkedinSvg';
import InstagramSvg from './svgs/InstagramSvg';
import YoutubeSvg from './svgs/YoutubeSvg';
import MediumSvg from './svgs/MediumSvg';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

export function Footer() {
  const { t } = useTranslation();



  return (
    <div>

      <Helmet>
        <meta name="description" content={t("meta.description")} />
        <meta name="keywords" content={t("meta.keywords")} />
        <meta name="author" content={t("meta.author")} />
      </Helmet>
      <div className="w-[90%] m-auto border-t border-[#60c8f4] font-medium text-center text-sm text-white"></div>
      <footer className="text-white lg:px-24 mt-10 lg:mt-0 sm:pb-10 md:pb-0 lg:pb-0">
        <div className="w-full flex flex-col lg:flex-row justify-between lg:items-baseline gap-8 lg:py-12 items-center">
          {/* Contact Section */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl font-bold">{t("footer.title")}</h2>
            <ul className="mt-4 text-sm flex flex-col gap-2">
              <li className="flex flex-row items-left justify-left ">
                <span className="mr-2">
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 1024 1024"
                    className="w-4 h-4 fill-white"
                    preserveAspectRatio="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M517.802667 612.181333c96.298667-5.12 152.874667-91.946667 181.205333-168.704 45.226667-10.154667 45.226667-71.552 11.349333-97.109333 8.021333-79.744 34.816-194.090667-65.28-198.314667-27.093333-1.109333-43.093333-26.496-145.834666-18.474666-62.592 5.034667-125.056 15.104-163.712 49.450666-39.594667 35.2-37.248 103.296-27.093334 172.458667-34.048 20.48-22.741333 81.834667 22.570667 97.152 28.288 76.629333 90.538667 168.618667 186.794667 163.541333z m114.133333 17.834667c-31.232 58.154667-49.066667 126.848-80.298667 179.669333-4.437333-36.992-3.84-61.269333-4.437333-137.386666h-75.776c4.437333 95.146667 4.437333 95.146667-4.522667 137.386666-22.314667-58.112-44.544-126.805333-75.776-179.626666-133.717333 21.12-231.850667 84.522667-236.245333 264.192h713.386667c-0.085333-179.669333-102.656-243.072-236.373334-264.234667z"
                    ></path>
                  </svg>
                </span>
                <p>{t("footer.contact.name")}</p>
              </li>
              <li className="flex items-left justify-left">
                <span className="mr-2">
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 1024 1024"
                    className="w-4 h-4 fill-white"
                    preserveAspectRatio="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M702.229 505.85l257.369 208.406V297.444zM599.854 588.749c-25.344 20.528-56.423 30.791-87.498 30.791-31.08 0-62.155-10.264-87.513-30.796l-53.778-43.556L65.846 792.386c2.945 22.208 13.831 41.923 29.75 56.193 7.592 6.805 16.341 12.319 25.868 16.329 10.846 4.566 22.712 7.164 35.207 7.164h711.225c15.817 0 30.632-4.139 43.612-11.24 9.122-4.99 17.365-11.399 24.295-19.056 12.221-13.502 20.449-30.628 22.931-49.554l-305.078-247.04-53.802 43.567zM64.969 297.272v417.157l257.529-208.577z"
                    ></path>
                  </svg>
                </span>
                <a
                  href="mailto:wasifshehzad063@gmail.com"
                  className="break-words"
                >
                  {t("footer.contact.email")}
                </a>
              </li>
            </ul>
          </div>

          {/* Schedule a Call Section */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl font-bold hidden md:flex lg:flex">{t("Navbar.schedule")}</h2>
            <p className="mt-4 text-sm hidden md:flex lg:flex">
              {t("footer.scheduleCall.description")} <br /> {t("footer.scheduleCall.description1")}
            </p>
            <div className="flex justify-center lg:justify-start space-x-4 md:mt-4 lg:mt-4">
              <a
                href="https://calendly.com/wasifshehzad063/30min?month=2024-09"
                target="_blank"
                className="schedule-btn border-2 border-[#5ecaf4] text-end rounded-md px-4 py-2 text-md font-medium text-white hover:text- transition-all duration-300 ease-in-out"
                aria-current="page"
              >
                {t("Navbar.schedule")}
              </a>
            </div>

          </div>
          {/* Social Icons Section */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl font-bold">{t('footer.followUs.title')}</h2>
            <div className="mt-4 grid grid-cols-6 md:grid-cols-6 lg:grid-cols-10 sm:gap-2 md:gap-12 lg:gap-16 justify-center lg:justify-start">
              <a href="https://www.facebook.com/Wasif.shehzad" target="_blank" rel="noopener noreferrer">
                <div className="relative group">
                  <button className="mb-2 inline-block rounded px-2 py-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg">
                    <span  className="[&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-10 md:[&>svg]:w-10 lg:[&>svg]:h-9 lg:[&>svg]:w-9">
                      <FacebookSvg />
                    </span>
                  </button>
                  <span className="absolute bottom-full left-1/2 hidden w-max -translate-x-1/2 transform rounded bg-[#ffffff] px-2 py-1 text-xs text-black opacity-0 group-hover:opacity-100 group-hover:block transition-opacity duration-150">
                    {t('socialMedia.facebook')}
                  </span>
                </div>
              </a>
              <a href="https://github.com/wasif-shehzad" target="_blank" rel="noopener noreferrer">
                <div className="relative group">
                  <button className="mb-2 inline-block rounded px-2 py-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg">
                    <span  className="[&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-10 md:[&>svg]:w-10 lg:[&>svg]:h-9 lg:[&>svg]:w-9">
                      <GithubSvg />
                    </span>
                  </button>
                  <span className="absolute bottom-full left-1/2 hidden w-max -translate-x-1/2 transform rounded bg-[#ffffff] px-2 py-1 text-xs text-black opacity-0 group-hover:opacity-100 group-hover:block transition-opacity duration-150">
                    {t('socialMedia.github')}
                  </span>
                </div>
              </a>
              <a href="https://www.linkedin.com/in/wasif-shehzad-2b29b798/" target="_blank" rel="noopener noreferrer">
                <div className="relative group">
                  <button className="mb-2 inline-block rounded px-2 py-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg">
                    <span  className="[&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-10 md:[&>svg]:w-10 lg:[&>svg]:h-9 lg:[&>svg]:w-9">
                      <LinkedinSvg />
                    </span>
                  </button>
                  <span className="absolute bottom-full left-1/2 hidden w-max -translate-x-1/2 transform rounded bg-[#ffffff] px-2 py-1 text-xs text-black opacity-0 group-hover:opacity-100 group-hover:block transition-opacity duration-150">
                    {t('socialMedia.linkedin')}
                  </span>
                </div>
              </a>
              <a href="https://www.instagram.com/wasif_shehzad/" target="_blank" rel="noopener noreferrer">
                <div className="relative group">
                  <button className="mb-2 inline-block rounded px-2 py-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg">
                    <span  className="[&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-10 md:[&>svg]:w-10 lg:[&>svg]:h-9 lg:[&>svg]:w-9">
                      <InstagramSvg />
                    </span>
                  </button>
                  <span className="absolute bottom-full left-1/2 hidden w-max -translate-x-1/2 transform rounded bg-[#ffffff] px-2 py-1 text-xs text-black opacity-0 group-hover:opacity-100 group-hover:block transition-opacity duration-150">
                    {t('socialMedia.instagram')}
                  </span>
                </div>
              </a>
              <a href="https://www.youtube.com/@wasifshehzad1987" target="_blank" rel="noopener noreferrer">
                <div className="relative group">
                  <button className="mb-2 inline-block rounded px-2 py-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg">
                    <span  className="[&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-10 md:[&>svg]:w-10 lg:[&>svg]:h-9 lg:[&>svg]:w-9">
                      <YoutubeSvg />
                    </span>
                  </button>
                  <span className="absolute bottom-full left-1/2 hidden w-max -translate-x-1/2 transform rounded bg-[#ffffff] px-2 py-1 text-xs text-black opacity-0 group-hover:opacity-100 group-hover:block transition-opacity duration-150">
                    {t('socialMedia.youtube')}
                  </span>
                </div>
              </a>
              <a href="https://wasifshehzad063.medium.com/" target="_blank" rel="noopener noreferrer">
                <div className="relative group">
                  <button className="mb-2 inline-block rounded px-2 py-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg">
                    <span  className="[&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-10 md:[&>svg]:w-10 lg:[&>svg]:h-9 lg:[&>svg]:w-9">
                      <MediumSvg />
                    </span>
                  </button>
                  <span className="absolute bottom-full left-1/2 hidden w-max -translate-x-1/2 transform rounded bg-[#ffffff] px-2 py-1 text-xs text-black opacity-0 group-hover:opacity-100 group-hover:block transition-opacity duration-150">
                    {t('socialMedia.medium')}
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )

}

